import React, { useState, useEffect, useRef } from "react";
import { Popup, Swiper, Image } from "antd-mobile";
import useActiveState from "../../lib/useActiveState";
import "./css/Mask.css";
import osName from "../../OsName";
import { useLocalStorageState } from "ahooks";
import MobileDetect from "mobile-detect";
import { inWechat } from "../wechat/Index";
import IllustratedTutorial from "./IllustratedTutorial";

const mobileDetect = new MobileDetect(navigator.userAgent);

export default function Mask() {
  const [app] = useActiveState("app");
  const [start, setStart] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [init, setInit] = useState(false);
  const [index, setIndex] = useState(0);
  const swiper = useRef();
  const array = ["", "", ""];
  const harmonyArray = ["", ""];
  const [harmonyFlag, setHarmonyFlag] = useLocalStorageState("harmonyFlag", 0);
  const [show26VersionImg, set26ShowVersionImg] = useState(false);
  const [visible, setVisible] = useState(false);
  const [switchingSteps, setSwitchingSteps] = useState(false);

  const harmonyItems = harmonyArray.map((item, index) => (
    <Swiper.Item key={index}>
      <div className="swipe-pic">
        <Image src={`resources/mask/harmony_${index + 1}.gif`} />
        <div className="swipe-pic-index">第{index + 1}步</div>
      </div>
    </Swiper.Item>
  ));

  const items = array.map((item, index) => (
    <Swiper.Item key={index}>
      <div className="swipe-pic">
        {app.appname.search("01") !== -1 ? (
          <Image src={`resources/mask/01-${index + 1}.gif`} />
        ) : app.appname.search("05") !== -1 ? (
          <Image src={`resources/mask/05-${index + 1}.gif`} />
        ) : app.appname.search("惠爪") !== -1 ? (
          <Image src={`resources/mask/hz-${index + 1}.gif`} />
        ) : (
          <Image src={`resources/mask/${index + 1}_1.gif`} />
        )}
        <div className="swipe-pic-index">第{index + 1}步</div>
      </div>
    </Swiper.Item>
  ));

  useEffect(() => {
    if (osName() == "Harmony") {
      setHarmonyFlag(1);
      setHidden(true);
      setTimeout(() => {
        setIndex(1);
      }, 3000);
    } else {
      let version = 0;
      // 优先通过正则直接从 UA 获取 iOS 版本，处理 mobileDetect 获取不准的问题
      // 优先尝试匹配 Version/ (针对 Version 与 OS 版本不一致的情况)
      let match = navigator.userAgent.match(/Version\/(\d+)[_.]/);
      if (!match) {
        match = navigator.userAgent.match(/OS\s+(\d+)[_.]/);
      }
      
      if (match && match[1]) {
        version = parseInt(match[1], 10);
      } else {
        let versionStr = mobileDetect.versionStr('iPhone');
        if (versionStr) {
          version = parseInt(versionStr.split('_')[0], 10);
        }
      }
      if (version >= 26) {
        set26ShowVersionImg(true);
      }else {
        setTimeout(() => {
          setStart(true);
        }, 10000);
      }
    }
  }, []);

  useEffect(() => {
    if (start && !init) {
      setInit(true);
      setTimeout(() => {
        setHidden(true);
      }, 750);
      setTimeout(() => {
        setIndex(1);
      }, 2000);
    }
  }, [start]);

  useEffect(() => {
    if (osName() == "Harmony") {
      if (index == 0) {
        setTimeout(() => {
          setIndex(1);
          swiper.current.swipeNext();
        }, 3000);
      } else {
        setTimeout(() => {
          setIndex(0);
          swiper.current.swipeNext();
        }, 3000);
      }
    } else {
      if (index == 0) {
        setTimeout(() => {
          setIndex(1);
          swiper.current.swipeNext();
        }, 2000);
      } else {
        const time = index == 2 ? 2000 : 3000;
        setTimeout(() => {
          setIndex(index == 2 ? 0 : 2);
          swiper.current.swipeNext();
        }, time);
      }
    }
  }, [index]);

  return (
    <div>
      {!inWechat() && <Popup
        className="mask-index"
        visible={true}
        bodyStyle={{
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
          overflow: "hidden",
        }}
      >
        <div className="mask-header">
          <Image
            className="mask-header-icon"
            src={app.appicon}
            style={{ borderRadius: 8 }}
          />
          <div className="mask-content">
            <div className="mask-content-title">快速添加桌面应用</div>
            <div className="mask-content-desc">便捷启动·全屏体验</div>
          </div>
        </div>
        <div className="mask-container">
          {hidden ? (
            <Swiper defaultIndex={0} ref={swiper} loop={true}>
              {osName() == "Harmony" ? harmonyItems : items}
            </Swiper>
          ) : null}
          <div
            className="mask-pic-index"
            style={{
              opacity: start ? "0" : "1",
              display: hidden ? "none" : "",
            }}
          >
            {!show26VersionImg && <Image className="mask-pic" src="resources/mask/start.png" />}
            {show26VersionImg && (
              <>
                <Image 
                  className="mask-pic" 
                  src="resources/mask/start_26.png" 
                  style={{ display: switchingSteps ? 'none' : 'block' }} 
                />
                <Image 
                  className="mask-pic" 
                  src="resources/mask/start_26_1.png" 
                  style={{ display: switchingSteps ? 'block' : 'none' }} 
                />
              </>
            )}
            
            {show26VersionImg && <div style={{padding:'0px 25px',color: "#282828", fontSize: 14, }}>
              <div style={{backgroundColor:'#fafafa',padding:'10px 15px',borderRadius: 8,lineHeight: 1.8}}>
                <div style={{fontWeight: 500}}>无法正常添加桌面应用？可尝试：</div>
                <div>1、找不到“···”按钮？<span onClick={()=>{
                  setSwitchingSteps(e => !e);
                }} style={{textDecoration:'underline',color:'var(--MainColor)'}}>切换添加步骤</span></div>
                <div>2、<span onClick={() =>  setVisible(true)} style={{textDecoration:'underline',color:'var(--MainColor)'}}>查看图文教程</span></div>
                </div>
            </div>}
            <IllustratedTutorial visible={visible} onClose={() => setVisible(false)}></IllustratedTutorial>
          </div>
        </div>
      </Popup>}
    </div>
  );
}
